import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {zoneOptions, centralPowerControlOptions} from '../../../sectionConfig';



@customElement('page-light-profile')
export class PageLightProfile extends connect(store)(LitElement) {

	static styles = [
		css`

			.lightProfileDetails {
				width: 97vw;
				display: block;
			}

			.summaryContent {
				display: table;
				width: 97vw;
			}

			p {
				font: var(--font-specsheet-print-light);
				line-height: 10.5px;
				margin: 0;
			}

			p span {
				font: var(--font-specsheet-print-bold);
				line-height: 10.5px;
				margin: 0;
			}

			.description {
				width: 50%;
			}

			.description h5 {
				font-size: var(--font-size-sections);
				font-weight: bold;
				margin: 1em 0;
			}

			.lightDiagram {
				margin: auto;
				margin-top: var(--specsheet-large-gap);
				width: 97vw;
			}

			.lightDiagram img {
				width: 100vw;
			}

			@media print {
				canvas {
					height: 100vw;
				  	width: 100vw;
				}
			  }
	  `
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.location = state.lightProfile.data.project.location;
		this.lang = state.status.lang;
	}

	render() {
		const s = this.state;
		const zpo = zoneOptions.find(zoneOption => zoneOption.id === this.lightProfile.project.zone);
		const zonelabel = zpo ? zpo.label[this.lang] : '';
		const power = centralPowerControlOptions.find( centralPowerControlOption =>  centralPowerControlOption.id === this.lightProfile.project.centralPowerControl);
		const powerlabel = power ? power.label[this.lang] : '';
		const powerinfo = power ? power.info[this.lang] : '';
		return html`

                <div slot="content">
                    <page-header content-title="${msg('Annual chart')}" label-choice="profile"></page-header>
                    <section class="lightProfileDetails">
                        <div class="summaryContent">
                            <p><span>${msg('Location')}</span> ${this.location.name}</p>
                            <p><span>${msg('Zone')}</span> ${zonelabel}</p>
							<p><span>${powerlabel}</span> ${powerinfo}</p>
                            <light-profile-year size="800"></light-profile-year>
                        </div
                        <div class="lightDiagram">

                        </div
                    </section>
                </div>
                <page-footer></page-footer>



		`;
	}
}
